import React, { useState,useEffect } from "react";
import DashboardNavbar from "../../components/DashboardNavbar";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import FeedbackDashboard from "../../containers/FeedbackDashboard/FeedbackDashboard";
import "../../styles/DashboardNavbar.css";

const index = ({pageID,title}) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const [navTitle, setnavTitle] = useState("Admin Console");


  useEffect(() => {
    setnavTitle(title);
  }, [title]);

  const toggle = () => setToggleBtn((val) => !val);

  const handleCloseButtonClick = () => {
    setToggleBtn(false); // Set toggleBtn to false
  };
  
  return (
    <div className="top-wrapper">
      <Sidebar toggleBtn={toggleBtn} 
      onCloseButtonClick={handleCloseButtonClick}
      activeMenu="Dashboards"/>
      <DashboardNavbar
        setToggle={toggle}
        navTitle={navTitle}
        type={pageID}
      />
      <Content toggleBtn={toggleBtn}>
      <FeedbackDashboard />
      </Content>
    </div>
  );
};

export default index;